export default "__VITE_ASSET__V$S$ZxzE__"